import {Container} from "@mui/material";

export default function LoadingMessage() {
    return (<Container sx={{display: 'flex', justifyContent: 'center', py:1}}>
        <div className="loader"/>
    </Container>)
}